var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import bindAssign from './bind-assign';
/**
 * Like lodash bindAll, but can take a function as with bindAll, and also can assign the bound methods
 * to another object instead of monkey patching the original.
 *
 * @param {any} target The object to assign each method
 * @param {any} source The object whose methods will be bound and mapped to target
 * @param {...any} args Things to bind: strings, or an array, or a function invoked for each method name
 * @returns {any} The bound object
 */
export default function bindAllTo(target, source) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return bindAssign.apply(void 0, __spreadArrays([target, source, source], args));
}
//# sourceMappingURL=bind-all-to.js.map